/** Fades a section in when it scrolls into view; static when the user prefers reduced motion. */
import { useEffect, useRef, type ReactNode } from 'react';

export function Reveal({ children, as: Tag = 'section', label }: { children: ReactNode; as?: 'section' | 'div'; label?: string }) {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      el.classList.add('is-visible');
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref as never} className="reveal" aria-label={label}>
      {children}
    </Tag>
  );
}
